import {
    ChangeDetectionStrategy,
    contentChildren,
    DestroyRef,
    Component,
    ElementRef,
    inject,
    viewChild,
    input,
    computed,
    type Signal,
} from '@angular/core';
import { FormField } from '@angular/forms/signals';
import { MatDialogContent, MatDialogModule } from '@angular/material/dialog';
import { Loader } from '../loader/loader';
import { DialogDraftState } from './dialog-draft-state';
import type { ProcessingAppearance } from './models';

export interface DialogContentPublic {
    nativeElement: Signal<HTMLElement>;
}

@Component({
    selector: 'qpx-dialog-content',
    imports: [MatDialogModule, Loader],
    templateUrl: './dialog-content.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'contents',
    },
    exportAs: 'qpxDialogContent',
})
export class DialogContent implements DialogContentPublic {
    private readonly forms = contentChildren(FormField, {
        descendants: true,
    });

    constructor() {
        const drafts = inject(DialogDraftState, { optional: true });
        const unregister = drafts?.register(() =>
            this.forms().some((form) => form.field()().dirty())
        );
        if (unregister) inject(DestroyRef).onDestroy(unregister);
    }

    //#region Inputs
    public readonly contentClass = input('');
    public readonly isProcessing = input(false);
    public readonly processingAppearance = input<ProcessingAppearance>('body');
    //#endregion

    //#region Template references
    private readonly dialogContent = viewChild.required<
        MatDialogContent,
        ElementRef<HTMLElement>
    >(MatDialogContent, {
        read: ElementRef,
    });
    //#endregion

    //#region Public properties
    public readonly nativeElement = computed(
        () => this.dialogContent().nativeElement
    );
    //#endregion
}
